module.exports = __webpack_public_path__ + "static/img/foto_login.a4aacdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Login/foto_login.png
// module id = 1626
// module chunks = 6